import React, { useContext, useEffect, useState } from 'react'
import { AcademyEvent } from '../../Api'
import { Box } from '../../Components/Layout'
import { AcademyGamedayEventCon } from './styles'
import { AcademyContext } from '../../Context/AcademyContext/AcademyContext'
import { Desc, Head2 } from '../../Components/Typography/Text.styles'
import { PLL_IMAGES } from '../../Config/config'
import { logEvent } from '../../Utils'
import { Img } from '../../Components/Image/Img'
import { Lk } from '../../Components/Links/Lk'

type AcademyWeekendEventProps = {
  market: string
}

export const AcademyWeekendEvent: React.FC<
  React.PropsWithChildren<AcademyWeekendEventProps>
> = ({ market }) => {
  let { academyEvents, loading, getGameWeekendEvents } = useContext(AcademyContext)!
  const [academyWeekendEvent, setAcademyWeekendEvent] = useState<AcademyEvent>()

  useEffect(() => {
    if (!loading && academyEvents && academyEvents?.length > 0) {
      let acEv = getGameWeekendEvents(market)
      if (acEv) {
        setAcademyWeekendEvent(acEv)
      }
    }
  }, [academyEvents])

  return (
    <>
      {!loading && academyWeekendEvent && (
        <Box vertMargins={2}>
          <Head2>Academy Gameday Events</Head2>
          <Desc>Gameday events bring hands-on lacrosse instruction from the pros to a fun, easy-paced environment.</Desc>
          <AcademyGamedayEventCon>
            {academyWeekendEvent.eventImg ? (
              <div className="imgCon">
                <Img
                  src={academyWeekendEvent.eventImg}
                  alt={`${academyWeekendEvent.eventName} image `}
                />
              </div>
            ) : (
              <div className="imgCon">
                <Img
                  src={PLL_IMAGES.academyWatermark}
                  alt={`${academyWeekendEvent.eventName} image `}
                />
              </div>
            )}
            <div className="infoCon">
              <div className="upper">
                <div className="date">
                  {academyWeekendEvent.formattedEventDate}
                  {academyWeekendEvent.eventTime
                    ? ` • ${academyWeekendEvent.eventTime}`
                    : ''}
                </div>
              </div>
              <div className="athCon">
                <p>Athletes</p>
                {academyWeekendEvent?.athletes.length > 0 && (
                  <div className="athName">
                    {academyWeekendEvent.athletes.join(', ')}
                  </div>
                )}
              </div>
              <Lk
                classNameObj="register"
                link={`${academyWeekendEvent.link}-${market}`}
                onClick={() =>
                  logEvent('academy_gameday_event_click', {
                    event_name: academyWeekendEvent.eventName,
                    date: academyWeekendEvent.formattedEventDate,
                    market: market,
                    link: academyWeekendEvent.link,
                  })
                }
                alt="Register for Academy Gameday Event"
              >
                Register
              </Lk>
            </div>
          </AcademyGamedayEventCon>
        </Box>
      )}
    </>
  )
}
